/** F606 Weight Logs page — per-user weight journal. */
import { Scale } from 'lucide-react';
import F606DataPage from './F606DataPage';

export default function F606WeightLogsPage() {
  return (
    <F606DataPage
      entity="weight-logs"
      titleAr="سجلات الوزن"
      titleEn="Weight logs"
      icon={Scale}
      emptyIcon={Scale}
      columns={[
        {
          key: 'id',
          ar: '#', en: '#',
          render: (r) => <span className="font-mono text-white/40 text-[10px]" dir="ltr">{String(r.id || '').slice(0, 8)}</span>,
          className: 'w-20',
        },
        { key: 'user_name', ar: 'المستخدم', en: 'User', render: (r) => <span className="font-bold text-white">{r.user_name || '—'}</span> },
        {
          key: 'weight_kg',
          ar: 'الوزن', en: 'Weight',
          render: (r) => r.weight_kg != null ? <span className="font-mono font-bold text-white" dir="ltr">{Number(r.weight_kg).toFixed(1)} kg</span> : '—',
          className: 'w-28',
        },
        {
          key: 'change',
          ar: 'التغيّر', en: 'Δ',
          render: (r) => {
            const d = r.delta_kg ?? r.change_kg;
            if (d == null) return '—';
            const v = Number(d);
            const color = v < 0 ? 'text-emerald-300' : v > 0 ? 'text-amber-300' : 'text-white/50';
            const sign = v > 0 ? '+' : '';
            return <span className={`font-mono ${color}`} dir="ltr">{sign}{v.toFixed(2)}</span>;
          },
          className: 'w-20',
        },
        { key: 'body_fat_pct', ar: 'الدهون', en: 'Fat %', render: (r) => r.body_fat_pct != null ? <span className="font-mono text-[11px] text-white/60" dir="ltr">{Number(r.body_fat_pct).toFixed(1)}%</span> : '—', className: 'w-20' },
        {
          key: 'logged_at',
          ar: 'التاريخ', en: 'Date',
          render: (r) => r.logged_at || r.created_at ? new Date(r.logged_at || r.created_at).toLocaleDateString() : '—',
          className: 'w-28 text-[11px] text-white/60',
        },
      ]}
    />
  );
}
